import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';

import { useLanguage } from '../../hooks';
import { ActivatedMobileUserMinimumData } from '../../types';
import { Checkbox } from '../uiComponents/ComponentLibrary/Checkbox';

const customStyles: Record<string, SxProps<Theme>> = {
  list: {
    overflowY: 'auto',
  },
  listItem: {
    padding: 0,
    paddingBottom: '6px',
    marginTop: '10px',
  },
  radioButton: {
    color: '#D1D4D9',
  },
  listItemIcon: {
    minWidth: '0',
    marginRight: '10px',
  },
  userListItem: {
    padding: 0,
  },
  userListItemIcon: {
    minWidth: '0',
    marginRight: '10px',
  },
  singleUserTitle: {
    marginLeft: '38px',
  },
};

interface UserListProps {
  users: ActivatedMobileUserMinimumData[];
  selectedUsers: ActivatedMobileUserMinimumData[];
  onUserToggle: (user: ActivatedMobileUserMinimumData) => void;
  onAllUsersToggle: () => void;
  singleUser?: boolean;
}

export function UserList({
  users,
  selectedUsers,
  onUserToggle,
  onAllUsersToggle,
  singleUser,
}: UserListProps) {
  const lang = useLanguage();
  const isUserSelected = (user: ActivatedMobileUserMinimumData) =>
    selectedUsers.some((selectedUser) => selectedUser.id === user.id);

  const allUsersSelected = users.every((user) => isUserSelected(user));

  return (
    <Box sx={customStyles.list}>
      <List>
        <ListItem sx={customStyles.listItem}>
          <ListItemIcon sx={customStyles.listItemIcon}>
            {!singleUser && (
              <Checkbox
                checked={allUsersSelected}
                onChange={onAllUsersToggle}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            )}
          </ListItemIcon>
          <Typography
            fontWeight='500'
            fontSize='medium'
            sx={singleUser ? customStyles.singleUserTitle : {}}
          >
            {lang.formSignatureBuilder.usersTab}
          </Typography>
        </ListItem>
        <Divider />
        {users.map((user) => (
          <Box key={user.id}>
            <ListItem sx={customStyles.userListItem}>
              <ListItemIcon sx={customStyles.userListItemIcon}>
                {singleUser ? (
                  <Radio
                    checked={isUserSelected(user)}
                    onChange={() => onUserToggle(user)}
                    aria-label='controlled'
                    size='small'
                    sx={customStyles.radioButton}
                  />
                ) : (
                  <Checkbox
                    checked={isUserSelected(user)}
                    onChange={() => onUserToggle(user)}
                    aria-label='controlled'
                  />
                )}
              </ListItemIcon>
              <ListItemText primary={user.name?.trim() || user.email} />
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>
    </Box>
  );
}
